<template>
  <div>
    <div class="form-input mb-3" :class="{ error: !valid.email && validate }">
      <b-form-input
        placeholder="E-mail"
        type="email"
        v-model="new_user.email"
      />
      <small>Буде використовуватись як логін</small>
    </div>
    <div class="form-input mb-2" :class="{ error: !valid.phone && validate }">
      <vue-tel-input @validate="validatePhone" v-model="phone"></vue-tel-input>
      <small>На цей номер ми надішлемо Вам пароль для входу</small>
    </div>
    <div class="form-input mb-3 pt-2">
      <b-form-checkbox
        id="checkbox-confirm"
        v-model="accepted"
        name="checkbox-confirm"
        :value="true"
        :unchecked-value="false"
      >
        <strong
          style="margin-left: 10px"
          :class="{ error: validate && !valid.accepted }"
        >
          Підтверджую, що введені мною дані є актуальними
        </strong>
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      validate: false,
      phoneValid: false,
      accepted: false,
      phone: "",
      new_user: {
        phone: "",
        email: "",
      },
    };
  },
  computed: {
    valid() {
      let valid = {
        email: true,
        phone: true,
        accepted: true,
      };
      if (!this.phoneValid) {
        valid.phone = false;
      }
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (!re.test(String(this.new_user.email).toLowerCase())) {
        valid.email = false;
      }

      if (!this.accepted) {
        valid.accepted = false;
      }
      return valid;
    },
  },
  methods: {
    validatePhone(value) {
      console.log(value);
      if (value.valid) {
        this.new_user.phone = value.number;
        this.phoneValid = true;
      } else {
        this.phoneValid = false;
      }
    },
    confirm() {
      this.validate = true;
      let valid = true;
      for (var key in this.valid) {
        if (this.valid[key] == false) {
          valid = false;
        }
      }
      this.$emit("validate", {
        valid: valid,
        data: this.new_user,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
small {
  color: #999;
  display: block;
  font-size: 13px;
  margin-top: 4px;
}
</style>
